export default __webpack_public_path__ + "static/media/backgroundWinner.aaabb3b8.webp";